module.exports = __webpack_public_path__ + "static/media/cocolonanel.f2d06601.webp";